export default {"src":"/_next/static/media/artefact_white.2e4a6ca2.svg","height":300,"width":900,"blurWidth":0,"blurHeight":0};